import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Cell } from 'react-md';
import { withRouter, Redirect, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withSnackbar } from 'notistack';
import { fromJS } from 'immutable';

import {
  DashboardCard,
  DashboardCardQuotations,
  // Customer
  DlpkContactCard,
  DlpkDashboardCard,
  DlpkInfoCard,
} from '@coog/react-components';

import { get, isEqual } from 'lodash-es';

import * as dashboardActions from '../../Services/Dashboard/actions';
import * as authActions from '../../Services/Auth/actions';
import { stringifyQuery } from '../../Utils/Utils';
import { showAlerts } from '../Common/utils';
import { I18nMarkdown } from '../../Components/Markdown';
// import cn from 'classnames';

import './Dashboard.scss';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
    };
  }

  componentDidMount() {
    const { actions, timer } = this.props;
    actions.fetchDataForDashboard();
    actions.fetchUnpaidContractsForDashboard();
    this.interval = setInterval(() => {
      if (timer.isEnable) {
        actions.fetchDataForDashboard();
      } else {
        clearInterval(this.interval);
      }
    }, timer.interval);
  }

  componentDidUpdate(prevProps) {
    const { ready: prevAuth, alerts: prevAlerts, loading: prevLoading } = prevProps;
    const { auth, alerts, loading, enqueueSnackbar, strings } = this.props;
    if ((!isEqual(prevAuth, auth) || !isEqual(prevLoading, loading)) && !isEqual(prevAlerts, alerts)) {
      showAlerts({ enqueueSnackbar, alerts, strings });
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleGetRoute = ({ route, query }) => {
    this.setState({
      redirect: true,
      redirectTo: { route, query },
    });
  };

  getDashboardCard = (config, key) => {
    const { strings } = this.props;
    const { title, theme, data } = config;
    return (
      <DashboardCard
        key={key}
        title={title}
        theme={theme}
        strings={strings}
        onRoute={this.handleGetRoute}
        className={Cell.getClassName({ size: 3, phoneSize: 4 })}
        data={data}
      />
    );
  };

  getDlpkContactCard = (config, key) => {
    const { strings } = this.props;
    const { title, emailContact, phoneContact, scheduleContact, fill, extras } = config;

    return (
      <DlpkContactCard
        key={key}
        title={title}
        strings={strings}
        emailContact={emailContact}
        phoneContact={phoneContact}
        scheduleContact={scheduleContact}
        fill={fill}
        extras={extras}
      />
    );
  };

  getDlpkDashboardCard = (config, key) => {
    const { title, icon, label, link, fill } = config;
    const linkComponent = <Link to={link}>{label}</Link>;

    return <DlpkDashboardCard key={key} title={title} link={linkComponent} icon={icon} fill={fill} />;
  };

  getDashboardCardQuotations = (config, key) => {
    const { strings } = this.props;
    const { title, action, quotations } = config;
    // overwrite action
    const importantAction = {
      labelBtn: 'dashboardCardQuotation.action.labelBtn.start',
      route: '/surveys/new',
    };
    return (
      <DashboardCardQuotations
        key={key}
        title={title}
        strings={strings}
        onRoute={this.handleGetRoute}
        className={Cell.getClassName({ size: 3, phoneSize: 4 })}
        action={importantAction || action}
        quotations={quotations}
      />
    );
  };

  i18nProcessing = ({ data = [], title = '', theme, fill }) => {
    const { strings } = this.props;
    const i18nTitle = <ReactMarkdown>{title ? get(strings, title) : ''}</ReactMarkdown>;
    const i18nData = data.map(row => {
      const label = get(row, 'label') ? get(strings, get(row, 'label')) : '';
      return { ...row, label };
    });
    return { data: i18nData, title: i18nTitle, theme, fill };
  };

  getDlpkInfoCard = (config, key) => {
    const { strings } = this.props;
    const { title, theme, data, fill } = this.i18nProcessing(config);
    return (
      <DlpkInfoCard
        key={key}
        title={title}
        theme={theme}
        strings={strings}
        onRoute={this.handleGetRoute}
        className={Cell.getClassName({ size: 3, phoneSize: 4 })}
        data={data}
        fill={fill}
      />
    );
  };

  getBlockTitle = (strings = {}) => (
    <I18nMarkdown className="block-title" strings={strings} string="block.title.reportings" />
  );

  render() {
    const { widgets, defaultWidgets, strings = {}, i18n, pageTitle, theme } = this.props;
    const { redirect, redirectTo } = this.state;

    // if (redirect) return <Redirect to={{pathname: `$redirectTo.route${redirectTo.query ? stringifyQuery(redirectTo.query, '?') : ''}` }} />;
    if (redirect) {
      const search = stringifyQuery(redirectTo.query, '?');
      return (
        <Redirect
          to={{
            pathname: redirectTo.route,
            search,
          }}
        />
      );
    }

    return (
      <div className="coog-app dashboard">
        <Helmet
          htmlAttributes={{
            class: 'coog',
            lang: i18n.lang,
          }}
        >
          <meta charSet="utf-8" />
          <title>{get(strings, pageTitle, pageTitle)}</title>
          <meta name="description" content={get(strings, pageTitle)} />
          <link rel="canonical" href={get(strings, 'canonical')} />
        </Helmet>
        <h1 className="md-title md-cell md-cell--12 title">
          <I18nMarkdown className="block-title" strings={strings} string={pageTitle} />
        </h1>
        <Grid className="coog-grid">
          <div className="widgets block">
            <div className=" default">
              {defaultWidgets.map(widget => {
                const { config, position, component, conditions } = widget;
                const condition = get(conditions, '[0].value', 'default');
                if (condition === 'default' || condition === get(theme, 'current')) {
                  switch (component) {
                    case 'DlpkContactCard': {
                      return this.getDlpkContactCard(config, position);
                    }
                    case 'DlpkDashboardCard': {
                      return this.getDlpkDashboardCard(config, position);
                    }
                    default:
                      return undefined;
                  }
                }
                return undefined;
              })}
            </div>
            {this.getBlockTitle(strings)}
            <div className="dynamic">
              {widgets.map(widget => {
                const { config, position, component } = widget;
                switch (component) {
                  case 'DashboardCardQuotations':
                    return this.getDashboardCardQuotations(config, position);
                  case 'DashboardCard':
                    return this.getDashboardCard(config, position);
                  case 'DlpkInfoCard': {
                    return this.getDlpkInfoCard(config, position);
                  }
                  default:
                    return undefined;
                }
              })}
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

Dashboard.propTypes = {
  pageTitle: PropTypes.string,
  actions: PropTypes.shape({
    logout: PropTypes.func.isRequired,
    settings: PropTypes.func.isRequired,
    getRoute: PropTypes.func,
    fetchDataForDashboard: PropTypes.func,
    fetchUnpaidContractsForDashboard: PropTypes.func,
  }),
  strings: PropTypes.shape({
    pageTitle: PropTypes.string,
    canonical: PropTypes.string,
  }),
  /* eslint-disable-next-line react/forbid-prop-types */
  widgets: PropTypes.array, // TODO: define better PropTypes
  /* eslint-disable-next-line react/forbid-prop-types */
  defaultWidgets: PropTypes.array, // TODO: define better PropTypes
  i18n: PropTypes.shape({ lang: PropTypes.string }),
  timer: PropTypes.shape({ isEnable: PropTypes.bool, interval: PropTypes.number }).isRequired,
  /* eslint-disable-next-line react/forbid-prop-types */
  theme: PropTypes.object,
  alerts: PropTypes.object, // eslint-disable-line
  loading: PropTypes.bool,
  ready: PropTypes.bool,
  enqueueSnackbar: PropTypes.func.isRequired,
  auth: ImmutablePropTypes.contains({
    loading: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    errorText: PropTypes.string,
    inError: PropTypes.bool,
  }),
};

Dashboard.defaultProps = {
  pageTitle: 'title',
  actions: {
    logout: () => {},
    settings: () => {},
    getRoute: route => {
      // eslint-disable-next-line no-console
      console.log('getRoute::', route);
    },
    fetchDataForDashboard: () => {},
    fetchUnpaidContractsForDashboard: () => {}
  },
  strings: {
    pageTitle: 'Dashboard',
    canonical: 'http://www.coopengo.com/',
  },
  widgets: [],
  defaultWidgets: [],
  i18n: {},
  theme: {},
  loading: true,
  ready: false,
  auth: fromJS({
    loading: false,
    isAuthenticated: false,
    inError: false,
    errorText: 'Identifiants incorrects',
  }),
};

const mapStateToProps = state => {
  const dashboard = state.get('dashboard').toJS();
  const theme = state.get('theme').toJS();
  return {
    i18n: state.getIn(['system', 'i18n'], {}).toJS(),
    strings: get(dashboard, 'strings', {}),
    widgets: get(dashboard, 'widgets', []),
    defaultWidgets: get(dashboard, 'defaultWidgets', []),
    timer: get(dashboard, 'timer', {}),
    theme,
    alerts: state.getIn(['auth', 'alerts']),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...dashboardActions, ...authActions }, dispatch),
});

export default withRouter(withSnackbar(connect(mapStateToProps, mapDispatchToProps)(Dashboard)));
